module.exports = __webpack_public_path__ + "img/edge_activites_speleologie.01740917.svg";